export default function dig<T = any>(path: string, obj: any): T {
  return path
    .split(".")
    .reduce((prev, curr) => (prev ? prev[curr] : undefined), obj);
}
